// extracted by mini-css-extract-plugin
export default {"p_tye":"_2d8e967c85","slcted":"_33f27680bd","slc_color":"_113dfa8c4a","item_p":"a586275a34","r0":"c501a087a8"};